import React, {
  useCallback, useRef, useState,
} from 'react';
import { Link } from "react-router-dom";
import {
  Container, Row, Col, Button,
} from 'reactstrap';
import classnames from 'classnames';
import { Field } from 'react-final-form';
import SweetAlert from "react-bootstrap-sweetalert";

import {
  Form, Intl, PaymentModal, Select, LocalTable,
} from 'components';
import { formatNumeral, formatPhone } from 'utils';
import { required } from 'config/InputErrors';

export default ( {
  phoneNumbers, isLoading, countries, countriesLoading,
  onReloadAccount, onSubmit, onFetchPhoneNumbers, userData, accountData, parentPath,
} ) => {
  const [paymentModal, setPaymentModal] = useState( false );
  const [warningModal, setWarningModal] = useState(false);
  const formDataRef = useRef( null );

  const togglePaymentModal = useCallback( ( formData ) => {
    if (accountData && accountData.fiscalName!==null && accountData.fiscalName!=="") {
      formDataRef.current = formData;
      setPaymentModal((state) => !state);
    } else {
      setWarningModal((state) => !state);
    }
  }, [accountData] );

  return (
    <Container
      fluid
      className={classnames( {
        'app-component-loading': isLoading,
      } )}
    >
      <Form
        showErrorsInHeader
        onSubmit={togglePaymentModal}
        body={( form ) => {
          const formValues = form.getState().values || {};
          return (
            <>
              <Row className="mt-5">
                <Col md={4}>
                  <Select
                    placeholder="selectCountryArea"
                    field="country"
                    validate={required}
                    options={countries}
                    isLoading={countriesLoading}
                    onChange={( value ) => {
                      if ( value ) onFetchPhoneNumbers( value );
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Row className="mb-1">
                    <Col>
                      <Intl id="selectNumber" />
                    </Col>
                  </Row>
                  <Field name="phoneNumber" validate={required} type="select">
                    {( { meta, input } ) => {
                      const isInvalid = ( meta.touched && meta.error )
                        || ( meta.touched && !meta.dirtySinceLastSubmit && !!meta.submitError );

                      return (
                        <div className="table-overflow table-overflow-w-100">
                          <LocalTable
                            data={phoneNumbers.length < 5
                              ? phoneNumbers.concat( new Array( 5 - phoneNumbers.length )
                                .fill( { empty: true } ) )
                              : phoneNumbers}
                            manualPagination
                            onlyTable
                            getRowProps={( row ) => ( {
                              onClick: () => {
                                if ( row.original && row.original.id ) {
                                  input.onChange( row.original.id );
                                  form.change( 'amount', row.original.amount );
                                  if((accountData && accountData.taxes) || (accountData && accountData.vat==="")) {
                                    const iva = row.original.amount
                                      ? Number( row.original.amount ) * 0.21 : null;
                                    form.change( 'iva', iva );
                                    const total = row.original.amount
                                      ? Number( row.original.amount ) + iva : null;
                                    form.change( 'total', total );
                                  } else {
                                    form.change( 'iva', 0 );
                                    const total = row.original.amount
                                      ? Number( row.original.amount ) : null;
                                    form.change( 'total', total );
                                  }
                                  
                                }
                              },
                              className: formValues.phoneNumber && formValues.phoneNumber === row.original.id ? 'bg-orange-6' : '',
                            } )}
                            columns={[
                              {
                                Header: 'number',
                                accessor: 'number',
                                Cell: ( { cell } ) => ( cell.value ? formatPhone( cell.value ) : '' ),
                              },
                              {
                                Header: 'amountMonthCurrency',
                                accessor: 'amount',
                                Cell: ( { cell } ) => ( cell.row.original.id ? formatNumeral( cell.value ) : '' ),
                              },
                            ]}
                            values={{ currency : userData.currency_symbol }}
                          />

                          {isInvalid
                          && (
                            <div className="invalid-feedback d-block">
                              <Intl id={meta.error || meta.submitError} />
                            </div>
                          )}
                        </div>
                      );
                    }}
                  </Field>
                  <Col className="text-sm">
                    <Intl id="footNodeOnAdministration" />
                  </Col>
                </Col>

                <Col md={8} className="mt-4 mt-md-0">
                  <Row className="mb-2">
                    <Col className="text-center">
                      <Intl id="clickToPayMonthly" />
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={4} md={7} className="m-auto">
                      <Row>
                        <Col className="offset-md-2">
                          <div className="bg-mp-orange-7 d-flex align-items-center px-2" style={{ height: 33 }}>
                            {formValues.amount ? formatNumeral( formValues.amount ) : <span />}
                          </div>
                        </Col>
                        <Col md="auto" className="pl-md-0 mt-1 text-sm">
                          <Intl id="currency" values={{ currency: userData.currency_name }} />
                        </Col>
                      </Row>

                      {formValues.iva ? (<Row className="mt-3">
                        <Col md={2} className="mt-1 text-md-right p-md-0 text-sm">
                          <Intl id="iva" />
                        </Col>
                        <Col md>
                          <div className="bg-mp-gray-3 d-flex align-items-center px-2" style={{ height: 33 }}>
                            {formValues.iva ? formatNumeral( formValues.iva ) : <span />}
                          </div>
                        </Col>
                        <Col md="auto" className="pl-md-0 mt-1 text-sm">
                          <Intl id="currency" values={{ currency: userData.currency_name }} />
                        </Col>
                      </Row>) : null}

                      <Row className={formValues.iva ? "mt-1":"mt-3"}>
                        <Col md={2} className="mt-1 text-md-right p-md-0 text-sm">
                          <Intl id="total" />
                        </Col>
                        <Col md>
                          <div className="bg-mp-gray-3 d-flex align-items-center px-2" style={{ height: 33 }}>
                            {formValues.total ? formatNumeral( formValues.total ) : <span />}
                          </div>
                        </Col>
                        <Col md="auto" className="pl-md-0 mt-1 text-sm">
                          <Intl id="currency" values={{ currency: userData.currency_name }} />
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col className="text-center">
                          <Button
                            color="app-default"
                            size="app-sm"
                            className="font-weight-700 mr-2"
                          >
                            <Intl id="payHere" />
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                {paymentModal
                && (
                  <PaymentModal
                    paymentData={formDataRef.current}
                    open={paymentModal}
                    onClose={togglePaymentModal}
                    onSubmit={( paymentData, ...rest ) => onSubmit(
                      { ...paymentData, ddi: formDataRef.current.phoneNumber }, ...rest,
                    )}
                    onSuccessPayment={() => {
                      onReloadAccount();
                      togglePaymentModal();
                      form.initialize( {} );
                    }}
                  />
                )}
                {warningModal && (
                <SweetAlert
                  title=""
                  onConfirm={() => {}}
                  custom
                  show={warningModal}
                  showCloseButton
                  customButtons={<></>}
                  onCancel={() => setWarningModal(false)}
                  style={{ width: "fit-content" }}
                >
                  <span style={{ color: "#000000", padding: "0 5rem" }}>
                    <Intl id="errorNoNumber3" />
                    <Link to={`hired-numbers/billing`}>
                      {" "}
                      <Intl id="fiscalData" />{" "}
                    </Link>
                    <Intl id="errorNoNumber4" />
                  </span>
                </SweetAlert>
              )}
              </Row>
            </>
          );
        }}
      />
    </Container>
  );
};
